import {object, string} from "yup";
import {IAuthSignIn} from "../../../types/auth";

export default object<IAuthSignIn>().shape({
	email: string().trim().required("ERRORS.FORM.REQUIRED").email("ERRORS.FORM.INVALID_EMAIL"),
	pwd: string().trim().required("ERRORS.FORM.REQUIRED"),
});
